export default __webpack_public_path__ + "static/media/ActiveAppraisal.14b26f45.svg";